const must = (k: string) => {
  const v = (import.meta as any).env[k];
  if (!v) throw new Error(`Missing env ${k}. Copy .env.example -> .env.local`);
  return v as string;
};

export const config = {
  region: must('VITE_AWS_REGION'),
  userPoolId: must('VITE_COGNITO_USER_POOL_ID'),
  clientId: must('VITE_COGNITO_CLIENT_ID'),
  apiBase: must('VITE_API_BASE').replace(/\/$/, ''),
  tokenRedeemUrl: must('VITE_TOKEN_REDEEM_URL').replace(/\/$/, '')
};
